export default __webpack_public_path__ + "static/media/discipline-applied-sciences.f179248b.svg";